module.exports = __webpack_public_path__ + "static/biomechanics_01-da4dd254aa50a528e82d088ca522d65d.jpg";